export const MediaDownloadController = () => {
    "ngInject";
};


// WEBPACK FOOTER //
// ./sources/components/media/media-download/media-download.js